import list from './list'
import profile from './profile'
import transactions from './transactions'
import creditCard from './credit-card'
import invoice from './invoice'
import logs from './logs'

let sharedMutations = []

export default {
  strict: true,
  namespaced: true,
  state: Object.assign(
    list.state,
    profile.state,
    transactions.state,
    creditCard.state,
    invoice.state,
    logs.state
  ),
  mutations: Object.assign(
    list.mutations,
    profile.mutations,
    transactions.mutations,
    creditCard.mutations,
    invoice.mutations,
    logs.mutations
  ),
  sharedMutations: sharedMutations
}



// WEBPACK FOOTER //
// ./src/store/corporate/index.js